import { getApiBaseUrl } from '../utils/apiConfig';

// Use the same domain as the frontend to ensure cookies work properly
export const API_BASE = getApiBaseUrl();
export const AUTH_HEADER = 'Authorization'; 